import React from 'react';
import { Sparkles, ArrowRight } from 'lucide-react';
import { Button } from '../ui/button';

const ExpoSection = ({ data }) => {
  const expos = data?.features || [];

  return (
    <section id="expos" className="py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            {data?.section_title || "Flagship Events"}
          </h2>
          <div 
            className="text-xl text-gray-600 max-w-2xl mx-auto [&>p]:mb-2 [&>b]:font-semibold [&>strong]:font-semibold [&>i]:italic [&>em]:italic [&>a]:text-gray-600 [&>a]:underline [&>a:hover]:text-gray-400 [&>h1]:text-4xl [&>h1]:font-extrabold [&>h1]:mb-3 [&>h1]:text-gray-900 [&>h2]:text-3xl [&>h2]:font-bold [&>h2]:mb-3 [&>h2]:text-gray-900 [&>h3]:text-2xl [&>h3]:font-bold [&>h3]:mb-2 [&>h3]:text-gray-800 [&>h4]:text-xl [&>h4]:font-semibold [&>h4]:mb-2 [&>h4]:text-gray-800 [&>h5]:text-lg [&>h5]:font-medium [&>h5]:mb-2 [&>h5]:text-gray-700 [&>h6]:text-base [&>h6]:font-medium [&>h6]:mb-1 [&>h6]:text-gray-700 [&>ul]:list-disc [&>ul]:ml-6 [&>ul]:mb-2 [&>ol]:list-decimal [&>ol]:ml-6 [&>ol]:mb-2 [&>li]:mb-1"
            dangerouslySetInnerHTML={{ __html: data?.section_description || "Join us at NYC's most anticipated tech gatherings" }}
          />
        </div>

        <div className="space-y-12">
          {expos.map((expo, index) => (
            <div
              key={index}
              className={`flex flex-col lg:flex-row items-center gap-8 lg:gap-12 ${
                index % 2 === 1 ? 'lg:flex-row-reverse' : ''
              }`}
            >
              <div className="w-full lg:w-1/2">
                <div className="relative rounded-2xl overflow-hidden shadow-2xl group">
                  <img
                    src={expo.image}
                    alt={expo.title}
                    className="w-full h-80 object-cover group-hover:scale-105 transition-transform duration-500"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent"></div>
                  <div className="absolute bottom-6 left-6 right-6">
                    <div className="inline-block bg-white/90 backdrop-blur-sm px-4 py-2 rounded-full text-sm font-semibold text-gray-900 mb-2">
                      {expo.date}
                    </div>
                  </div>
                </div>
              </div>

              <div className="w-full lg:w-1/2 space-y-6">
                <div>
                  <div className="inline-block bg-gray-900 text-white px-3 py-1 rounded-full text-sm font-medium mb-3">
                    {expo.subtitle}
                  </div>
                  <h3 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
                    {expo.title}
                  </h3>
                  <p className="text-lg text-gray-600 leading-relaxed">
                    {expo.description}
                  </p>
                </div>

                {expo.features && (
                  <div className="space-y-3">
                    {expo.features.map((feature, idx) => (
                      <div key={idx} className="flex items-start space-x-3">
                        <Sparkles className="text-gray-900 flex-shrink-0 mt-1" size={20} />
                        <span className="text-gray-700">{feature}</span>
                      </div>
                    ))}
                  </div>
                )}

                {(expo.cta_label || expo.cta_link) && (
                  <a 
                    href={expo.cta_link || '#'} 
                    className="inline-flex items-center bg-black hover:bg-gray-800 text-white mt-4 group px-4 py-2 rounded-md font-medium transition-colors"
                  >
                    {expo.cta_label || 'Learn More'}
                    <ArrowRight className="ml-2 group-hover:translate-x-1 transition-transform" size={18} />
                  </a>
                )}
                {!expo.cta_label && !expo.cta_link && (
                  <Button className="bg-black hover:bg-gray-800 text-white mt-4 group">
                    Learn More
                    <ArrowRight className="ml-2 group-hover:translate-x-1 transition-transform" size={18} />
                  </Button>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ExpoSection;
